import { api } from '@/lib/api';

const anonId = () => {
  let id = localStorage.getItem('bx_anon');
  if (!id) { id = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem('bx_anon', id); }
  return id;
};

export const track = (name, props = {}) => {
  api.post('/events', { name, props, anon_id: anonId() }).catch(() => {});
};
